import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlanoDeContasListagemComponent } from './plano-de-contas-listagem/plano-de-contas-listagem.component';
import { PlanoDeContasAdicionarComponent } from './plano-de-contas-adicionar/plano-de-contas-adicionar.component';
import { PlanoDeContasEditarComponent } from './plano-de-contas-editar/plano-de-contas-editar.component';


const routes: Routes = [
    { path: '', component: PlanoDeContasListagemComponent },
    { path: 'adicionar', component: PlanoDeContasAdicionarComponent },
    { path: 'editar', component: PlanoDeContasEditarComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PlanoDeContasRoutingModule { }
